// Lets the Hub run full screen (no Safari bar) when it's opened from an
// iPad/iPhone Home Screen icon. index.html is a Retool platform file we can't
// edit, so the tags are added at startup; Safari reads them when "Add to Home
// Screen" is tapped, so the icon has to be added (again) after this ships.
const TAGS: Array<[string, string]> = [
  ['apple-mobile-web-app-capable', 'yes'],
  ['mobile-web-app-capable', 'yes'],
  ['apple-mobile-web-app-status-bar-style', 'default'],
  ['apple-mobile-web-app-title', "Poppin' Hub"],
]

export function addHomeScreenAppTags() {
  if (typeof document === 'undefined') return
  for (const [name, content] of TAGS) {
    if (document.head.querySelector(`meta[name="${name}"]`)) continue
    const meta = document.createElement('meta')
    meta.name = name
    meta.content = content
    document.head.appendChild(meta)
  }
}

// Changes the name Safari suggests for a Home Screen icon (e.g. "Scan Station"
// on the station view). It's read when "Add to Home Screen" is tapped.
export function setHomeScreenTitle(title: string) {
  if (typeof document === 'undefined') return
  addHomeScreenAppTags()
  const meta = document.head.querySelector<HTMLMetaElement>(
    'meta[name="apple-mobile-web-app-title"]',
  )
  if (meta) meta.content = title
}
